import React from 'react';
import { GraduationCap, Award, BookOpen, TrendingUp } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const achievements = [
  {
    id: 1,
    title: 'National Diploma in Information Technology',
    icon: GraduationCap,
    color: 'from-purple-500 to-purple-600',
    year: 2018,
  },
  {
    id: 2,
    title: 'Bachelors Degree in Information Technology: Software Development',
    icon: BookOpen,
    color: 'from-cyan-500 to-cyan-600',
    year: 2019,
  },
  {
    id: 3,
    title: 'Certified Digital Marketing Professional',
    icon: TrendingUp,
    color: 'from-cyan-500 to-purple-500',
    year: 2021,
  },
  {
    id: 4,
    title: 'ITIL V4 Foundation Certified',
    icon: Award,
    color: 'from-purple-500 to-cyan-500',
    year: 2026,
  },
];

const Education = () => {
  const [titleRef, titleVisible] = useScrollAnimation(0.2);
  const [gridRef, gridVisible] = useScrollAnimation(0.1);

  return (
    <section className="py-24 px-4 md:px-8 relative">
      <div className="max-w-6xl mx-auto">
        <h2
          ref={titleRef}
          className={`text-5xl md:text-6xl font-bold mb-16 text-center scroll-animate ${titleVisible ? 'visible' : ''}`}
        >
          <span className="bg-gradient-to-r from-purple-400 to-cyan-400 bg-clip-text text-transparent">
            Education & Certifications
          </span>
        </h2>

        <div
          ref={gridRef}
          className={`grid grid-cols-1 md:grid-cols-2 gap-6 scroll-animate ${gridVisible ? 'visible' : ''}`}
        >
          {achievements.map((achievement) => {
            const IconComponent = achievement.icon;
            return (
              <div
                key={achievement.id}
                className="group relative overflow-hidden rounded-2xl bg-zinc-900/40 backdrop-blur-sm border border-zinc-800 hover:border-purple-500/50 transition-all duration-500 hover:shadow-xl hover:shadow-purple-500/20 p-6"
              >
                {/* Hover glow effect */}
                <div className="absolute inset-0 bg-gradient-to-br from-purple-600/0 to-cyan-500/0 group-hover:from-purple-600/5 group-hover:to-cyan-500/5 transition-all duration-500"></div>

                <div className="relative flex items-start gap-4">
                  {/* Icon with gradient background */}
                  <div
                    className={`flex-shrink-0 w-14 h-14 rounded-xl bg-gradient-to-br ${achievement.color} p-3 shadow-lg group-hover:scale-110 transition-transform duration-300`}
                  >
                    <IconComponent className="w-full h-full text-white" />
                  </div>

                  {/* Text content */}
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-zinc-100 group-hover:text-purple-300 transition-colors leading-snug">
                      {achievement.title}
                    </h3>
                  </div>
                  <div className="flex">
                    <h3 className="text-lg font-semibold text-slate-400 group-hover:text-purple-300 transition-colors leading-snug justify-center align-middle">
                      {achievement.year}
                    </h3>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Education;
